import * as api from '../api/agentBeta';

import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const AGENT_FETCH_PROPERTY_AGENTS = createRequestTypes('APPRAISAL/AGENT_FETCH_PROPERTY_AGENTS');

export const fetchPropertyAgents = makeApiActionCreatorV3(
  api.fetchPropertyAgents,
  AGENT_FETCH_PROPERTY_AGENTS[START],
  AGENT_FETCH_PROPERTY_AGENTS[SUCCESS],
  AGENT_FETCH_PROPERTY_AGENTS[ERROR],
);

export const AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING = createRequestTypes('APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING');

export const fetchPropertyAccountNameListing = makeApiActionCreatorV3(
  api.fetchPropertyAccountNameListing,
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING[START],
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING[SUCCESS],
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING[ERROR],
);

export const AGENT_INSERT_PROPERTY_OWNER_AGENT = createRequestTypes('APPRAISAL/AGENT_INSERT_PROPERTY_OWNER_AGENT');

export const insertPropertyOwnerAgent = makeApiActionCreatorV3(
  api.insertPropertyOwnerAgent,
  AGENT_INSERT_PROPERTY_OWNER_AGENT[START],
  AGENT_INSERT_PROPERTY_OWNER_AGENT[SUCCESS],
  AGENT_INSERT_PROPERTY_OWNER_AGENT[ERROR],
);

export const AGENT_FETCH_PROPERTY_OWNER_AGENT = createRequestTypes('APPRAISAL/AGENT_FETCH_PROPERTY_OWNER_AGENT');

export const fetchPropertyOwnerAgent = makeApiActionCreatorV3(
  api.fetchPropertyOwnerAgent,
  AGENT_FETCH_PROPERTY_OWNER_AGENT[START],
  AGENT_FETCH_PROPERTY_OWNER_AGENT[SUCCESS],
  AGENT_FETCH_PROPERTY_OWNER_AGENT[ERROR],
);

export const AGENT_RESET_PROPERTY_OWNER_AGENT =
  'APPRAISAL/AGENT_RESET_PROPERTY_OWNER_AGENT';
  
export const resetPropertyOwnerAgent = () => ({
  type: AGENT_RESET_PROPERTY_OWNER_AGENT,
});

export const AGENT_RESET_AGENTS_BY_NAME =
  'APPRAISAL/AGENT_RESET_AGENTS_BY_NAME';
export const resetAgentsByName = () => ({
  type: AGENT_RESET_AGENTS_BY_NAME,
});

export const AGENT_UPDATE_PROPERTY_OWNER_AGENT = createRequestTypes('APPRAISAL/AGENT_UPDATE_PROPERTY_OWNER_AGENT');
  
export const updatePropertyOwnerAgent = makeApiActionCreatorV3(
  api.updatePropertyOwnerAgent,
  AGENT_UPDATE_PROPERTY_OWNER_AGENT[START],
  AGENT_UPDATE_PROPERTY_OWNER_AGENT[SUCCESS],
  AGENT_UPDATE_PROPERTY_OWNER_AGENT[ERROR],
);

export const AGENT_DELETE_PROPERTY_OWNER_AGENT = createRequestTypes('APPRAISAL/AGENT_DELETE_PROPERTY_OWNER_AGENT');

export const deletePropertyOwnerAgent = makeApiActionCreatorV3(
  api.deletePropertyOwnerAgent,
  AGENT_DELETE_PROPERTY_OWNER_AGENT[START],
  AGENT_DELETE_PROPERTY_OWNER_AGENT[SUCCESS],
  AGENT_DELETE_PROPERTY_OWNER_AGENT[ERROR],
);

export const AGENT_FETCH_PROPERTY_OWNER_FILES = createRequestTypes('APPRAISAL/AGENT_FETCH_PROPERTY_OWNER_FILES');
  
export const fetchPropertyOwnerAgentFiles = makeApiActionCreatorV3(
  api.fetchPropertyOwnerAgentFiles,
  AGENT_FETCH_PROPERTY_OWNER_FILES[START],
  AGENT_FETCH_PROPERTY_OWNER_FILES[SUCCESS],
  AGENT_FETCH_PROPERTY_OWNER_FILES[ERROR],
);

export const AGENT_INSERT_PROPERTY_OWNER_FILE = createRequestTypes('APPRAISAL/AGENT_INSERT_PROPERTY_OWNER_FILE');

export const insertPropertyOwnerAgentFile = makeApiActionCreatorV3(
  api.insertPropertyOwnerAgentFile,
  AGENT_INSERT_PROPERTY_OWNER_FILE[START],
  AGENT_INSERT_PROPERTY_OWNER_FILE[SUCCESS],
  AGENT_INSERT_PROPERTY_OWNER_FILE[ERROR],
);

export const AGENT_DELETE_PROPERTY_OWNER_FILE = createRequestTypes('APPRAISAL/AGENT_DELETE_PROPERTY_OWNER_FILE');

export const deletePropertyOwnerAgentFile = makeApiActionCreatorV3(
  api.deletePropertyOwnerAgentFile,
  AGENT_DELETE_PROPERTY_OWNER_FILE[START],
  AGENT_DELETE_PROPERTY_OWNER_FILE[SUCCESS],
  AGENT_DELETE_PROPERTY_OWNER_FILE[ERROR],
);

export const AGENT_DOWNLOAD_PROPERTY_OWNER_FILE = createRequestTypes('APPRAISAL/AGENT_DOWNLOAD_PROPERTY_OWNER_FILE');

export const downloadPropertyOwnerAgentFile = makeApiActionCreatorV3(
  api.downloadPropertyOwnerAgentFile,
  AGENT_DOWNLOAD_PROPERTY_OWNER_FILE[START],
  AGENT_DOWNLOAD_PROPERTY_OWNER_FILE[SUCCESS],
  AGENT_DOWNLOAD_PROPERTY_OWNER_FILE[ERROR],
);

export const AGENT_UPDATE_PROPERTY_OWNER_FILE = createRequestTypes('APPRAISAL/AGENT_UPDATE_PROPERTY_OWNER_FILE');

export const updatePropertyOwnerAgentFile = makeApiActionCreatorV3(
  api.updatePropertyOwnerAgentFile,
  AGENT_UPDATE_PROPERTY_OWNER_FILE[START],
  AGENT_UPDATE_PROPERTY_OWNER_FILE[SUCCESS],
  AGENT_UPDATE_PROPERTY_OWNER_FILE[ERROR],
);